import { render, staticRenderFns } from "./PlanCategory.vue?vue&type=template&id=d39627ba"
import script from "./PlanCategory.vue?vue&type=script&lang=js"
export * from "./PlanCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports